import { isNative } from '@bubble-ui/util-platform';
var accessibilityPresets = {
  none: {
    tag: 'span'
  },
  paragraph: {
    tag: 'paragraph',
    role: isNative ? undefined : 'paragraph'
  },
  'heading 1': {
    tag: 'h1',
    role: 'heading',
    'aria-level': 1
  },
  'heading 2': {
    tag: 'h2',
    role: 'heading',
    'aria-level': 2
  },
  'heading 3': {
    tag: 'h3',
    role: 'heading',
    'aria-level': 3
  }
};
export var getAccessibilityPresetAttrs = preset => accessibilityPresets[preset];
//# sourceMappingURL=accessibilityPresets.js.map